<template>
	<div class="cateBox-mask" v-show="boxStatus">
		<div class="box">
			<header class="box-H flex between">
				<div></div>
				<section class="box-H-title">请选择您要咨询的业务</section>
				<img @click="boxSwitch(false)" class="box-H-close" src="@/assets/robot/close.png" alt="">
			</header>
			<footer class="box-M">
				<nav class="cate-nav flex between">
					<div class="nav-item" 
					v-for="(cate1,cate1_Index) in cateList" :key="cate1_Index" @click="switchIndex(cate1_Index)">
						<div>
							<span class="nav-item-txt"
							:class="[ cate1_Index === currentIndex ?'nav-item-txt-active' : '']"
							>{{cate1.name}}</span>
							<div class="nav-item-icon"
							:class="[ cate1_Index === currentIndex ?'nav-item-icon-active' : '']"
							></div>
						</div>
					</div>
				</nav>
				
				<article v-if="cateList.length" class="cate-detail" ref="content"  @scroll="divScroll">	
					<section class="cate-detail-Menu1"  
					ref="cateItem"
					v-for="(cate1,cate1_Index) in cateList" :key="cate1_Index">
						<header class="cate-detail-Menu1-H flex">
							<img class="cate-detail-Menu1-H-icon" src="@/assets/robot/cateReply/cate-icon.png" alt="">
							<span class="cate-detail-Menu1-H-txt">{{cate1.name}}</span>
						</header>
						<footer class="cate-detail-Menu1-C flex">
							<div v-for="(cate2,cate2_Index) in cate1.children" :key="cate2_Index"
							@click="selectCate2(cate1_Index, cate2_Index)"
							class="cate-detail-Menu1-C-item flex  center">{{cate2.name}}</div>
						</footer>
					</section>
					
					<div :style="{ height: height + 'px'}"></div>
				</article>
				
			</footer>
		</div>
	</div>
</template>

<script>
	import util from "@/util/util.js"
	export default {
		props: {
			cityname: {
				type: String,
				default: '深圳'
			},
		},
		data() {
			return {
				currentIndex: 0,
				boxStatus: false,
				cateList: [],
				height: 330,
				cateHeight: [],
				getHeight: true,
				accumulatorHeight: []
			}
		},
		mounted() {
			this.getCate();
		},
		watch: {
			boxStatus(newVal , oldVal ) {
				this.getCate();
			}
		},
		methods:{	
			/**
			* 滑动区域的高度
			* @method divScroll
			*/
			divScroll(e) {
				const sh = this.$refs.content.scrollHeight
				const ch = this.$refs.content.clientHeight
				// console.log(ch);
				const st = this.$refs.content.scrollTop
				// console.log(this.$refs.content.scrollTop);
				
				if (this.getHeight) {
					for ( let i = 0; i < this.cateList.length ; i++ ) {
						this.cateHeight.push(this.$refs.cateItem[i].clientHeight );
					}
					this.height = ch - this.cateHeight[this.cateList.length - 1];
					// console.log(this.height);
					
					this.accumulatorHeight.push(this.cateHeight[0]);
					
					this.cateHeight.reduce( (accumulator, currentValue, currentIndex, array) => {
						this.accumulatorHeight.push(accumulator);
						return accumulator + currentValue;
					});
	
					// console.log(this.accumulatorHeight);
					this.getHeight = false;
				}
				
				for (let i = 0 ; i < this.cateList.length ;i++ ) {
					if (i === 0) {
						if ( this.$refs.content.scrollTop < this.accumulatorHeight[i] - 3) {
							this.currentIndex = 0 ;
						}
					} 
					if (this.$refs.content.scrollTop > this.accumulatorHeight[i] - 3) {
						console.log(this.accumulatorHeight[i]);
						this.currentIndex = i ;
					}
				}
				
				// console.log('滚动条高度' + sh)
				// console.log('可视区高度' + ch)
				// console.log('距离顶部距离' + st)
				// if (ch + st== sh) {
				//   console.log('到底啦...')
				// }
			},			
			/**
			* 查找二级分类
			* @method selectCate2
			*/
			selectCate2(cate1_Index,cate2_Index) {
				this.boxSwitch(false);
				this.$emit("selectCate_two", { index1: cate1_Index , index2: cate2_Index });
			},	
			/**
			* 获取分类
			* @method getCate
			*/
			async getCate() {
				
				let data = {
					action: "cate_list",
					cityname: this.cityname,
				}
				
				let res = await util.request(data);
				if ( res.data.state ) {
					this.cateList = res.data.data;
				} else {
					this.cateList = [];
				}
			},
			/**
			* 切换分类
			* @method switchIndex
			*/
			switchIndex(index) {
				
					for ( let i = 0; i < this.cateList.length ; i++ ) {
						this.cateHeight.push(this.$refs.cateItem[i].clientHeight );
					}
					this.accumulatorHeight.push(this.cateHeight[0])
					
					this.cateHeight.reduce( (accumulator, currentValue, currentIndex, array) => {
						this.accumulatorHeight.push(accumulator);
						return accumulator + currentValue;
					});
					
					this.currentIndex = index;
					let currentScrollTop = this.$refs.content.scrollTop;
					let targetOffsetTop = 0;
										
					let step = 10;
					if ( index === 0) {									
						targetOffsetTop = 0;	
					} else {
						targetOffsetTop = this.accumulatorHeight[index];
					}
					
					if(currentScrollTop > targetOffsetTop){
					
					    const smoothUp = ()=>{
					        if(currentScrollTop >= targetOffsetTop){
					            if (currentScrollTop - targetOffsetTop >= step) {
					                currentScrollTop -= step;
					                setTimeout(smoothUp, 1);
					            } else {
					                currentScrollTop = targetOffsetTop;
					            }
								this.$refs.content.scrollTop = currentScrollTop ;
					        }
					    };
					    smoothUp();
						
					}else{
						
					    const smoothDown = ()=>{
					        if (currentScrollTop <= targetOffsetTop) {
					            // 如果和目标相差距离大于等于step 就跳 step
					            if (targetOffsetTop - currentScrollTop >= step) {
					                currentScrollTop += step;
					                setTimeout(smoothDown, 1);
					            } else {
					                // 否则直接跳到目标点，防止跳过
					                currentScrollTop = targetOffsetTop;
					            }
					            this.$refs.content.scrollTop = currentScrollTop;
					        }
					    };
					    smoothDown();
					}						
		
			},
			/**
			* 盒子开关
			* @method boxSwitch
			*/
			boxSwitch(val) {
				this.boxStatus = val;
			}
			
		}
		
	}
</script>

<style lang="stylus">
@keyframes boxShow {
	0% {
	  transform: translateY(100%);
	}
		
	100% {
	  transform: translateY(0%);
	}
}
	
@import './cateBox-pc.styl'
@import './cateBox-mobile.styl'
</style>
